<template>
  <div class="card border-secondary">
    <WCOrderPanelHeader
      :order="order"
      @cancelOrder="cancelOrder($event)"
      @editOrder="$emit('editOrder', order)"
      @receipt="$emit('receipt', order)"
      ref="orderPanelHeaderRef"
    />
    <WCOrderPanelBody
      :order="order"
      :isDetailPage="isDetailPage"
      @addToCart="addToCart"
      @replaceCart="replaceCart"
      @replaceReceipt="replaceReceipt"
    />
  </div>
</template>

<script>
import OrderPanelMixin from '@/modules/orders/mixins/OrderPanelMixin';
import WCOrderPanelHeader from './WCOrderPanelHeader.vue';
import WCOrderPanelBody from './WCOrderPanelBody.vue';

export default {
  props: {
    isDetailPage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WCOrderPanelHeader,
    WCOrderPanelBody,
  },
  mixins: [OrderPanelMixin],
  methods: {
    addToCart(order) {
      console.log('addToCart', order);
    },
    replaceCart(order) {
      console.log('replaceCart', order);
    },
    replaceReceipt(order) {
      console.log('replaceReceipt', order);
    },
    focus() {
      if (this.$refs.orderPanelHeaderRef) this.$refs.orderPanelHeaderRef.focus();
    },
  },
};
</script>

<style lang="scss" scoped></style>
